export const setLocalStorageOrganization = (data: {
  id: string;
  name: string;
}): void => {
  const { id, name } = data;
  // console.log("----->>>>", data);
  localStorage.setItem(
    "selected-organization",
    JSON.stringify({
      organization_id: id?.length > 0 ? id : "",
      organization_name: id?.length > 0 ? name : "",
    }),
  );

  setLocalStorageProperty({ id: "", name: "" });
  setLocalStoragePropertyList({ propertyIds: [] });
  // localStorage.removeItem("selected-property");
};

export const setLocalStorageProperty = (data: {
  id: string;
  name: string;
}): void => {
  const { id, name } = data;
  localStorage.setItem(
    "selected-property",
    JSON.stringify({
      property_id: id?.length > 0 ? id : "",
      property_name: id?.length > 0 ? name : "",
    }),
  );
};

export const setLocalStoragePropertyList = (data: any): void => {
  localStorage.setItem(
    "selected-property-list",
    JSON.stringify({
      property_ids: data?.propertyIds?.length > 0 ? data?.propertyIds : [],
      // property_name: data?.propertyName?.length > 0 ? data?.propertyName : "",
    }),
  );
};

const PAYMENT_STATUS_KEY = "selected-payment-status";
const PAYMENT_STATUS_LABELS: Record<"PAID" | "PARTIAL" | "UNPAID", string> = {
  PAID: "Paid",
  PARTIAL: "Partial",
  UNPAID: "Unpaid",
};

const toStoredPaymentStatus = (
  value: unknown,
): "PAID" | "PARTIAL" | "UNPAID" | "" => {
  const status = String(value ?? "").trim().toUpperCase();
  return status === "PAID" || status === "PARTIAL" || status === "UNPAID"
    ? status
    : "";
};

export const getLocalStoragePaymentStatus = (): {
  paymentStatus: string;
  paymentStatusLabel: string;
} => {
  try {
    const raw = localStorage.getItem(PAYMENT_STATUS_KEY);
    if (!raw) return { paymentStatus: "", paymentStatusLabel: "" };

    const parsed = JSON.parse(raw);
    const paymentStatus = toStoredPaymentStatus(
      parsed?.payment_status ?? parsed?.paymentStatus,
    );
    if (!paymentStatus) {
      localStorage.removeItem(PAYMENT_STATUS_KEY);
      return { paymentStatus: "", paymentStatusLabel: "" };
    }

    return {
      paymentStatus,
      paymentStatusLabel: PAYMENT_STATUS_LABELS[paymentStatus],
    };
  } catch {
    localStorage.removeItem(PAYMENT_STATUS_KEY);
    return { paymentStatus: "", paymentStatusLabel: "" };
  }
};

export const setLocalStoragePaymentStatus = (status: string): void => {
  const paymentStatus = toStoredPaymentStatus(status);
  if (!paymentStatus) {
    localStorage.removeItem(PAYMENT_STATUS_KEY);
    return;
  }

  localStorage.setItem(
    PAYMENT_STATUS_KEY,
    JSON.stringify({
      payment_status: paymentStatus,
      payment_status_label: PAYMENT_STATUS_LABELS[paymentStatus],
    }),
  );
};

// export const setLocalStorageOrganization_2 = (data: any): void => {
//   localStorage.setItem(
//     "selected-organization",
//     JSON.stringify({
//       organization_id:
//         data?.organizationId?.length > 0 ? data?.organizationId : "",
//       organization_name:
//         data?.organizationName?.length > 0 ? data?.organizationName : "",
//     }),
//   );
// };
